export default __webpack_public_path__ + "static/media/grass.d575943c.jpg";